
import {createBrowserRouter,RouterProvider} from "react-router-dom";
import Layout from "./Pages/Layout";
import HomePage from "./Pages/Home";
import SolutionsPage from "./Pages/Services";
import AboutPage from "./Pages/About";
import ContactPage from "./Pages/Contact";
import './App.css';
import './components.css'
import ProjectsPage from "./Pages/Projects";

function App() {
  const router= createBrowserRouter([
    {
      path:'/',
      element:<Layout />,
      children: [
        {
          index: true,
          path: '/',
          element: <HomePage />,
        },
        {
          path:'about',
          element: <AboutPage />,
        },
        {
          path: 'services',
          element: <SolutionsPage />,

        },
        {
          path: 'contact',
          element: <ContactPage />,
        },
        {
          path: 'projects',
          element: <ProjectsPage />
        }

      ]
    }
  ])

  return (
    <RouterProvider router={router}/>
  );
}

export default App;
